<ng-container *ngIf="(languageSelectorVisible$ | async) && (enableSiteContextSwitch$ | async) && !(inEditMode$ | async)">
  <ng-container
    *ngIf="{
      languages: languages$ | async,
      currentLanguage: currentLanguage$ | async,
      activeCountry: activeCountry$ | async,
    } as observables"
  >
    <ng-container *ngIf="observables.languages?.length > 0">
      <ng-container *ngIf="mode === modes.POP_OVER; else dropdownModeTemplate">
        <py-header-navigation-item
          #popOver="ngbPopover"
          container="body"
          [ngbPopover]="contentTemplate"
          [popoverClass]="'language-popover'"
          [autoClose]="'outside'"
          [placement]="['auto']"
          triggers="manual"
          [active]="popOver.isOpen()"
          (activate)="popOver.open()"
          (shown)="onPopoverShown()"
          (hidden)="onPopoverHidden()"
        >
          <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
          <div #overlayBody class="overlay-body" [class.visible]="popOver.isOpen()"></div>
        </py-header-navigation-item>
      </ng-container>

      <ng-template #dropdownModeTemplate>
        <div ngbDropdown #dropdown="ngbDropdown" [open]="showDropdown" (openChange)="onOpenChange($event)">
          <py-header-navigation-item class="header-mobile-item w-100" ngbDropdownToggle>
            <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
          </py-header-navigation-item>

          <div ngbDropdownMenu aria-labelledby="language-selector" class="language-selector-dropdown py-max-width">
            <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
          </div>
        </div>
      </ng-template>

      <ng-template #headerTemplate>
        <i
          nz-icon
          class="d-flex align-self-center flag-sprite {{ observables.activeCountry?.countryFlagSprite }}"
          [ngClass]="mode === modes.POP_OVER ? 'mr-2' : 'mr-3'"
        ></i>
        <span class="text-nowrap">{{
          languageWithFallback(
            'common.navigation.' + observables.currentLanguage?.isocode + '_title' | cxTranslate,
            observables.currentLanguage?.nativeName
          )
        }}</span>
      </ng-template>

      <ng-template #contentTemplate>
        <div class="header d-flex align-items-center justify-content-between p-3">
          <div class="d-flex justify-content-between align-items-start w-100">
            <h6>{{ 'navigation.language_title' | cxTranslate }}</h6>
            <button type="button" class="close ml-4" (click)="mode === modes.POP_OVER ? popover.close() : hideDropdown()">
              <i nz-icon pyIconThemeReverse nzType="close-circle" nzTheme="outline"> </i>
            </button>
          </div>
        </div>

        <div class="body-wrapper py-3 border-top">
          <div
            *ngFor="let language of observables.languages"
            class="d-flex language-item"
            [ngClass]="{ selected: observables.currentLanguage?.isocode === language?.isocode }"
          >
            <py-radio [showLabel]="true" class="w-100">
              <input
                type="radio"
                [checked]="observables.currentLanguage?.isocode === language?.isocode"
                (change)="selectLanguage(language?.isocode)"
              />
              <span slot="label">{{
                languageWithFallback('common.navigation.' + language.isocode + '_title' | cxTranslate, language.nativeName)
              }}</span>
            </py-radio>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-container>
